<template>
    <div class="main">
        <iframe src="https://jpjs.geeker.com.cn/dist/goodsShop/index.html#/" width="100%" height="100%"></iframe>
        <!--底部导航栏-->
        <!-- <Foot></Foot> -->
    </div>
</template>
<script>
import Foot from '../../components/Foot'
import P400 from '../../components/P400'
  import {wxShareme} from '@/utils/wechat'
export default {
    components: {Foot,P400},
    data() {
        return {

        }
    },
    created () {
        wxShareme('万物有声丨文创商城','精选文创 | 讲解文创 | AR文创 | 景区同款','https://jpjs.geeker.com.cn/dist/goodsShop/static/logo.png','/shopping');
    }
}
</script>
<style scoped>
.main{width: 100vw;height: 100vh;}
</style>


// WEBPACK FOOTER //
// src/page/shopping/shopping.vue